import ErrorLow from '@learningblocks/exp-constants/lib/Images/failure-low.7a4840c3.svg';
import ErrorMedium from '@learningblocks/exp-constants/lib/Images/failure-med.2ca29e00.svg';
import ErrorHigh from '@learningblocks/exp-constants/lib/Images/failure-high.0bb309f7.svg';

export const TOTAL_LEVELS = 3;
export const LEVEL_LIST = {
  low: {className: 'error-low', image: ErrorLow},
  medium: {className: 'error-medium', image: ErrorMedium},
  high: {className: 'error-high', image: ErrorHigh},
};
export const LEVELS = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
};
